import React from 'react';
import DocumentTitle from 'react-document-title';
import { Route, Switch } from 'react-router';
import NewsIndex from './NewsIndex';
import Details from './Details';

import './News.scss'



const News = ({match}) => (
  <div className="container mt-md-5 mt-3" id="news-container">
    <DocumentTitle title="Jaunumi - e-BML" />
    <Switch>
      <Route exact path={`${match.url}`} component={NewsIndex} />
      <Route path={`${match.url}/:id/`} component={Details} />
    </Switch>
  </div>
);

export default News;


// WEBPACK FOOTER //
// ./src/scenes/News/index.js